//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { throttle } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ScrollableContainer",
  data() {
    return {
      container: {},
      scrollLeft: 0,
      clientWidth: 0,
      scrollWidth: 0
    };
  },
  computed: {
    showLeftArrow() {
      return this.scrollLeft > 0;
    },
    showRightArrow() {
      return this.scrollLeft + this.clientWidth < this.scrollWidth;
    },
    containerMargin() {
      return this.showLeftArrow || this.showRightArrow ? "px-4" : "";
    }
  },
  created() {
    window.addEventListener("resize", this.handleWindowResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
  },
  mounted() {
    this.container = this.$refs.scrollRef.firstElementChild;
    this.setScrollProperties();
  },
  methods: {
    handleScrollLeft() {
      this.container.scrollLeft -= 150;
      this.setScrollProperties();
    },
    handleScrollRight() {
      this.container.scrollLeft += 150;
      this.setScrollProperties();
    },
    handleWindowResize: throttle(function () {
      this.setScrollProperties();
    }, 150),
    async setScrollProperties() {
      await this.$nextTick();
      this.scrollLeft = this.container.scrollLeft;
      this.clientWidth = this.container.clientWidth;
      this.scrollWidth = this.container.scrollWidth;
      await this.$nextTick();
    },
    recalculateWidth() {
      this.setScrollProperties();
    }
  }
});